import type {IOnChanges, IPostLink} from 'angular';
import type {User} from 'typings/portaro.be.types';
import type {Component} from 'typings/portaro.fe.types';
import type {IUserFinanceService, UserFinanceServiceFactory} from './user-finance.factory';

const CASH_PAYMENT_PROVIDER_TYPE = 'cash';
const TERMINAL_PAYMENT_PROVIDER_TYPE = 'terminal';
const GATEWAY_PAYMENT_PROVIDER_TYPE = 'gateway';

export const CASH_PAYMENT_PROVIDER_NAME = 'cash';
export const MANUAL_TERMINAL_PAYMENT_PROVIDER_NAME = 'terminal-virtual';

class UserFinancePanelComponentController implements UserFinancePanelComponentBindings, IPostLink, IOnChanges {

    public owner: User;
    public enabledPaymentProviderNames: string[];
    public userCanBeCashPaymentCashier: boolean;
    public userCanDeletePayment: boolean;
    public userCanDeleteDebt: boolean;
    private userFinanceService: IUserFinanceService;

    /*@ngInject*/
    constructor(private userFinanceServiceFactory: UserFinanceServiceFactory, private CONTEXT_PATH: string) {
    }

    public $postLink() {
        if (this.owner) {
            this.userFinanceService = this.userFinanceServiceFactory.getUserFinanceService(this.owner, this.userCanDeletePayment, this.userCanDeleteDebt);
            this.userFinanceService.loadAll();
        }
    }

    public $onChanges(onChangesObj: angular.IOnChangesObject): void {
        if (onChangesObj.owner && !onChangesObj.owner.isFirstChange()) {
            this.$postLink();
        }
    }

    public canShowPayButtonOf(paymentProviderName: string): boolean {
        const type = this.getPaymentProviderType(paymentProviderName);
        switch (type) {
            case CASH_PAYMENT_PROVIDER_TYPE: return true;
            case TERMINAL_PAYMENT_PROVIDER_TYPE: return true;
            case GATEWAY_PAYMENT_PROVIDER_TYPE: return this.userFinanceService.getDebtsSum() < 0;
        }
        throw new Error(`unknown payment provider type ${type}`);
    }

    public getPaymentProviderType(paymentProviderName: string): string {
        if (paymentProviderName === CASH_PAYMENT_PROVIDER_NAME) {
            return CASH_PAYMENT_PROVIDER_TYPE;
        }
        if (paymentProviderName === MANUAL_TERMINAL_PAYMENT_PROVIDER_NAME) {
            return TERMINAL_PAYMENT_PROVIDER_TYPE;
        }
        if (paymentProviderName.startsWith(GATEWAY_PAYMENT_PROVIDER_TYPE)) {
            return GATEWAY_PAYMENT_PROVIDER_TYPE;
        }
        throw new Error(`unknown payment provider with name ${paymentProviderName}`);
    }

}

/**
 * @ngdoc component
 * @name kpUserFinancePanel
 * @module portaro.uc.user.components
 *
 * @param {User} owner
 * @param {boolean} enabledPaymentProviderNames
 * @param {boolean} userCanDeletePayment
 * @param {boolean} userCanDeleteDebt
 */
// eslint-disable-next-line
export default class UserFinancePanelComponent implements Component<UserFinancePanelComponentBindings> {
    public static componentName = 'kpUserFinancePanel';

    public templateUrl = require('./user-finance-panel.tpl.ftl');
    public bindings = {
        owner: '<',
        enabledPaymentProviderNames: '<',
        userCanDeletePayment: '<',
        userCanDeleteDebt: '<'
    } as const;
    public controller = UserFinancePanelComponentController;

}

interface UserFinancePanelComponentBindings {
    owner: User;
    enabledPaymentProviderNames: string[];
    userCanDeletePayment: boolean;
    userCanDeleteDebt: boolean;
}
